import React from 'react';
import { Route, Switch } from 'react-router';
import SearchResults from './Global';
import SearchElements from './Elements';
import SearchProductions from './Productions';
import SearchArtists from './Artists';

const Search = () => (
  <Switch>
    <Route exact path="/search" component={SearchResults} />
    <Route exact path="/search/elements" component={SearchElements} />
    <Route exact path="/search/productions" component={SearchProductions} />
    <Route exact path="/search/artists" component={SearchArtists} />
    <Route exact path="/search/:query" component={SearchResults} />
  </Switch>
);

export default Search;



// WEBPACK FOOTER //
// ./src/containers/Search/index.js